import { BaseDataChannel, DataChannelConfiguration } from "./BaseDataChannel";
import * as THREE from 'three';
export class SynthMapChannel extends BaseDataChannel {
  public map = new SynthMap();
  constructor() {
    super();
  }
  public getConfiguration(): DataChannelConfiguration {
    return {
      name: 'synth_map',
    }
  }
  public onMessage(ev: MessageEvent): void {
    // console.log('synth map is getting data');
    const data = ev.data as ArrayBuffer;
    const buffer = new Int16Array(data);
    this.map.read(buffer);
    this.emit('map', this.map); 
  }
}

export class SynthMap {
  public lines: THREE.Vector3[] = [];
  public heights: number[] = [];
  public read(buffer: Int16Array) {
    const offsetX = buffer[0] / 100;
    const offsetY = buffer[1] / 100;
    const resolution = buffer[2] / 100;
    const lineCount = buffer[3];
    this.lines = [];
    let index = 4;
    for (let i = 0; i < lineCount; i++) {
      const x1 = buffer[index++];
      const y1 = buffer[index++];
      const x2 = buffer[index++];
      const y2 = buffer[index++];
      const height = buffer[index++] / 100; // unused for now
      this.lines.push(new THREE.Vector3(
        offsetX + x1 * resolution, 
        offsetY + y1 * resolution, 0));
      this.lines.push(new THREE.Vector3(
        offsetX + x2 * resolution, 
        offsetY + y2 * resolution, 0));
      this.heights.push(height);
    }    
  }
}